import { render, staticRenderFns } from "./accadvShowDtail.vue?vue&type=template&id=b08440d0&"
import script from "./accadvShowDtail.vue?vue&type=script&lang=js&"
export * from "./accadvShowDtail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b08440d0')) {
      api.createRecord('b08440d0', component.options)
    } else {
      api.reload('b08440d0', component.options)
    }
    module.hot.accept("./accadvShowDtail.vue?vue&type=template&id=b08440d0&", function () {
      api.rerender('b08440d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/accadvShowDtail.vue"
export default component.exports